export const checkIfAlreadySubscribedToPremium = (newsletterCode: string): boolean => {
  const crmUser = window?.crm_user;

  if (crmUser && crmUser.mail) {
    // Check if the user is already subscribed to the premium newsletter
    return crmUser.mail.some((mailItem: { code: string }) => mailItem.code === newsletterCode);
  }

  return false;
};
